window.smileTranslationMap = {
    // General
    "Your 꽃송이": "내 꽃송이",
    "Points": "꽃송이",
    "Cancel": "취소",
    "Continue": "계속",

    // Ways to earn
    "Ways to earn": "꽃송이 모으는 방법",
    "Place an order" : "주문 적립",
    "Signup": "회원가입",
    "Order discount" : "할인코드로 전환하기",
    "View" : "보기",

    // Ways to redeem
    "Ways to redeem": "꽃송이 사용하기",
    "Your activity" : "활동내역",
    "activity"      : "활동내역",
    "Redeem"        : "할인코드 발급하기",

    // Rewards / Coupons
    "Your Rewards"                                                                  : "내 할인코드 목록",
    "No rewards yet"                                                                : "아직 할인코드가 없습니다",
    "Get reward"                                                                    : "할인코드 받기",
    "Past rewards": "지난 할인코드 목록",
    "Apply code"                                                                    : "할인코드 적용",
    "Use this discount code on your next order!"                                    : "코드를 적용하면 주문금에 할인이 반영됩니다.",
    "Added to cart. Some discounts may not be visible until all conditions are met.": "적용되었습니다. 일부 할인은 모든 조건이 충족되어야 표시됩니다.",
    "You already have a reward available. Only one can be used per order - are you sure you want to redeem another reward?": "이미 사용 가능한 할인코드가 있습니다. 다른 할인코드를 추가로 발급하시겠습니까?",
    "Applies to one-time purchases."                                                : "다른 할인코드와 함께 적용할 수 있습니다.",
    "Reward can only be used while you're logged in. Applies to one-time purchases. Reward expires 1 year after being issued.": "원하시는 수량 만큼 할인코드로 발급하시고, 결제전에 할인 적용해주세요.  발급 후 1년 동안 유효합니다.",
    "View all rewards"                                                              : "모든 할인코드 목록 보기",
    
    // VIP
    "VIP"     : "회원 등급",
    "VIP Tier": "회원 등급",
    "Benefits": "등급 혜택",
    "Congratulations, you're in the highest tier": "축하합니다, 최고 등급이 되셨습니다",

    // Referrals
    "Referrals"                                                               : "추천 프로그램",
    "Refer your friends"                                                      : "친구 추천하기",
    "Give your friends a reward and claim your own when they make a purchase.": "친구에게 할인코드를 선물하고, 친구가 첫 구매를 완료하면 회원님께도 할인코드가 지급됩니다.",
    "Your referral code"                                                      : "나의 추천 코드",
    "They get"                                                                : "친구가 받는 혜택",
    "You get"                                                                 : "내가 받는 혜택",
    "No referral history"                                                     : "추천 내역 없음",
    "You haven't made any referrals yet."                                     : "아직 추천한 내역이 없습니다",
    "How do I make a referral?"                                               : "어떻게 친구를 추천하나요?",

    // Birthday
    "Celebrate a birthday"                                          : "생일축하 꽃송이",
    "We want to celebrate your birthday! Make sure you let us know at least one month in advance — otherwise, you'll have to wait until next year.": "고객님의 생일을 축하해 드리고 싶어요! 생일 최소 한 달 전에 정보를 입력해주세요. 그렇지 않으면 내년까지 기다려야 할 수 있습니다.",
    "Month"                                                                                                                                        : "월",
    "Day"                                                                                                                                          : "일",
    "Edit date"                                                                                                                                    : "날짜 수정",
    "Save date"                                                                                                                                    : "날짜 저장",

    // Status
    "Your points balance may not reflect your latest activity": "최근 활동은 아직 잔액에 반영되지 않을 수 있습니다.",
    "Placed an order"                                         : "주문 완료",
    "Canceled: Placed an order"                               : "주문 취소",
    "Wrote a product review": "상품 리뷰 작성",
    "Manual adjustment"                                       : "관리자에의한 포인트 조정",
    "Oops! Something went wrong."                                   : "죄송합니다! 문제가 발생했습니다.",
    "The page cannot be found at this time. Please try again later.": "현재 페이지를 찾을 수 없습니다. 잠시 후 다시 시도해주세요.",
    "Continue shopping"                                             : "닫기",
    // Other common phrases
};

// This is for handling dynamic text like "500 Points"
window.smileDynamicTextMap = [
    {
        // "You have 1 reward(s) available" -> "사용 가능한 할인혜택이 1개 있습니다"
        regex      : /You have ([\d,]+) reward(s)? available/gi,
        replacement: '사용 가능한 할인코드가 $1개 있습니다'
    },
    {
        regex      : /Spent ([\d,]+) 꽃송이/gi,
        replacement: '$1 꽃송이 사용'
    },
    {
        // "$9 off coupon" -> "$9 할인 쿠폰"
        regex      : /\$([\d,.]+) off coupon/gi,
        replacement: '$$$1 할인 쿠폰'
    },

    {
        // "1 꽃송이 for every $1 spent" -> "$1 사용 시마다 1 꽃송이 적립"
        regex      : /([\d,]+) 꽃송이 for every \$([\d,.]+) spent/gi,
        replacement: '$$$2 결제시 $1 꽃송이 적립'
    },
    {
        // "Earn 700 꽃송이 by December 31, 2026 to reach 꽃다발" -> "꽃다발 등급이 되려면 December 31, 2026까지 700 꽃송이를 더 모으세요."
        regex      : /Earn ([\d,]+) 꽃송이 by (.+?) to reach (.+)/gi,
        replacement: function (match, points, dateStr, tierName) {
            try
            {
                const date = new Date(dateStr);
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const koreanDate = `${year}년 ${month}월 ${day}일`;
                return `'${tierName}' 등급이 되려면 ${koreanDate}까지 ${points} 꽃송이를 더 모으세요.`;
            }
            catch (e)
            {
                // 날짜 변환에 실패하면 원래 문장을 유지합니다.
                return `'${tierName}' 등급이 되려면 ${dateStr}까지 ${points} 꽃송이를 더 모으세요.`;
            }
        }
    },
    {
        // "Earn 1,400 꽃송이" -> "1,400 꽃송이 적립"
        regex      : /Earn ([\d,]+) 꽃송이/gi,
        replacement: '$1 꽃송이 적립'
    },
    {
        // "Points spent on $9 할인 쿠폰 - 주문결제 할인" -> "'$9 할인 쿠폰' 사용"
        regex      : /Points spent on \$([\d,.]+) 할인 쿠폰 - 주문결제 할인/gi,
        replacement: `'$ $1 할인 쿠폰' 사용`
    },
    {
        // "Added to Gold" -> "'Gold' 등급으로 승급"
        regex      : /Added to (.+)/gi,
        replacement: `'$1' 등급으로 승급`
    },
    {
        // "Achieved 꽃다발" -> "'꽃다발' 등급 달성"
        regex      : /Achieved (.+)/gi,
        replacement: `'$1' 등급 달성`
    },
    {
        // "Member until December 31, 2027" -> "2027년 12월 31일까지 회원 유지"
        regex      : /Member until (.+)/gi,
        replacement: function (match, dateStr) {
            try
            {
                const date = new Date(dateStr);
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const koreanDate = `${year}년 ${month}월 ${day}일`;
                return `${koreanDate}까지 회원 유지`;
            }
            catch (e)
            {
                return `${dateStr}까지 회원 유지`;
            }
        }
    },
    {
        // "Expiration date: February 24, 2027" -> "만료일: 2027년 2월 24일"
        regex      : /Expiration date: (January|February|March|April|May|June|July|August|September|October|November|December) (\d{1,2}), (\d{4})/gi,
        replacement: function (match, monthStr, day, year) {
            const monthMap = {
                'January': 1, 'February': 2, 'March': 3, 'April': 4, 'May': 5, 'June': 6,
                'July'   : 7, 'August': 8, 'September': 9, 'October': 10, 'November': 11, 'December': 12
            };
            const month = monthMap[monthStr];
            if (month)
            {
                return `만료일: ${year}년 ${month}월 ${day}일`;
            }
            // 매칭되는 월이 없으면 원본 유지
            return match;
        }
    },
    {
        // "Reward can only be used while you're logged in. Applies to one-time purchases. Reward expires on September 18, 2027 23:59."
        // 또는 "Reward expires on September 18, 2027 23:59."
        regex      : /(?:Reward can only be used while you're logged in\.\s*Applies to one-time purchases\.\s*)?Reward expires on (January|February|March|April|May|June|July|August|September|October|November|December) (\d{1,2}), (\d{4})(?:\s+(\d{1,2}:\d{2}))?\.?/gi,
        replacement: function (match, monthStr, day, year, timeStr) {
            const monthMap = {
                'January': 1, 'February': 2, 'March': 3, 'April': 4, 'May': 5, 'June': 6,
                'July'   : 7, 'August': 8, 'September': 9, 'October': 10, 'November': 11, 'December': 12
            };
            const month = monthMap[monthStr];
            if (month)
            {
                const timePart = timeStr ? ` ${timeStr}` : '';
                return `로그인 시에만 사용 가능하며, 1회 구매에 적용됩니다. 할인코드 만료일: ${year}년 ${month}월 ${day}일${timePart}.`;
            }
            return match;
        }
    },
    {
        // "Jan 14, 2026" -> "2026년 1월 14일"
        regex      : /(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{1,2}), (\d{4})/gi,
        replacement: function (match, monthStr, day, year) {
            const monthMap = {
                'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
                'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
            };
            const month = monthMap[monthStr];
            if (month)
            {
                return `${year}년 ${month}월 ${day}일`;
            }
            // 매칭되는 월이 없으면 원본 유지
            return match;
        }
    },
    {
        // "0 referrals completed" -> "추천 완료 0건"
        regex      : /([\d,]+) referrals completed/gi,
        replacement: '추천 완료 $1건'
    },
    {
        // "Share this URL to give your friends the reward $5 할인 쿠폰" -> "친구에게 '$5 할인 쿠폰' 혜택을 주려면 이 URL을 공유하세요."
        regex      : /Share this URL to give your friends the reward (.+)/gi,
        replacement: `친구에게 '$1' 혜택을 주려면 이 URL을 공유하세요.`
    },
    {
        // "14200 꽃송이 for $142 off" 또는 "14200 Points for $142 off" -> "14,200 꽃송이 사용 ($142 할인)"
        regex      : /([\d,]+)\s*(?:Points|꽃송이)?\s*for\s*\$([\d,.]+)\s*off/gi,
        replacement: '$1 꽃송이 사용 ($$$2 할인)'
    },
    {
        // "Added 7 days after order" -> "주문 7일 후 적립"
        regex      : /Added (\d+) days after order/gi,
        replacement: '주문 $1일 후 적립'
    }
];
